import { render, staticRenderFns } from "./main-check.vue?vue&type=template&id=6b7ac54c&scoped=true&"
import script from "./main-check.vue?vue&type=script&lang=js&"
export * from "./main-check.vue?vue&type=script&lang=js&"
import style0 from "./main-check.vue?vue&type=style&index=0&id=6b7ac54c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7ac54c",
  null
  
)

export default component.exports